import { postJSON } from 'common/services/api'
import {
  REVISIONS_QUERY_KEY,
  REVISION_REOPEN_URL,
  REVISION_REOPEN_QUERY_KEY,
  REVISION_QUERY_KEY,
} from './queryConstants'
import { useMutation, useQueryClient } from 'react-query'

type UseRevisionReopenReturn = {
  reopenRevision?: () => Promise<unknown>
  isReopenRevisionLoading?: boolean
}

type UseRevisionReopenProps = {
  id?: string
}

const useRevisionReopen = ({
  id,
}: UseRevisionReopenProps): UseRevisionReopenReturn => {
  const queryClient = useQueryClient()

  // Reopen event
  const reopenFunction = async (): Promise<unknown> => {
    return postJSON({
      url: `${REVISION_REOPEN_URL}/${id}`,
      method: 'POST',
      isRota: true,
    })
  }

  const { mutateAsync: reopenMutation, isLoading: isReopenRevisionLoading } =
    useMutation<unknown>([REVISION_REOPEN_QUERY_KEY], reopenFunction, {
      onSuccess: () => {
        queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
        queryClient.invalidateQueries([REVISION_QUERY_KEY, id])
      },
    })

  const handleReopen = async () => {
    try {
      const result = await reopenMutation()
      return result
    } catch (err) {
      return err
    }
  }

  return {
    reopenRevision: handleReopen,
    isReopenRevisionLoading,
  }
}

export default useRevisionReopen
